import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-012ed941"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-search-preview" }
const _hoisted_2 = { class: "header-search-preview_label" }
const _hoisted_3 = { class: "header-search-preview_icon" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-search-preview_spacer" }, null, -1))
const _hoisted_5 = { class: "header-search-preview_label" }
const _hoisted_6 = { class: "header-search-preview_icon" }

import {useTranslation} from '@malt/vue3-use';
    import {ref} from 'vue';
    import {SearchPreviewTarget} from '../header-menu.types';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderSearchPreview',
  emits: ["openSearchForm"],
  setup(__props, { emit }) {

    

    const {msg} = useTranslation();

    const searchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(searchParams);

    const job = ref(params.q ?? msg('navbar.header.search.form.job.label'));
    const location = ref(params.location ?? msg('navbar.header.search.form.location.label'));

    function openSearchForm(target: SearchPreviewTarget) {
        emit('openSearchForm', target);
    }

return (_ctx: any,_cache: any) => {
  const _component_VJoyIcon = _resolveComponent("VJoyIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "header-search-preview_btn header-search-preview_btn-job",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (openSearchForm('JOB')))
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(job.value), 1),
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_VJoyIcon, {
          name: "search",
          color: "white"
        })
      ])
    ]),
    _hoisted_4,
    _createElementVNode("button", {
      class: "header-search-preview_btn header-search-preview_btn-loc",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (openSearchForm('LOCATION')))
    }, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(location.value), 1),
      _createElementVNode("span", _hoisted_6, [
        _createVNode(_component_VJoyIcon, {
          name: "search",
          color: "white"
        })
      ])
    ])
  ]))
}
}

})